import { writable } from "svelte/store";
import { auth, firestore } from "../firebase/firebase.js";
import { setLoader } from "./shared.js";
import { validateSignInEntries } from "../helpers/authHelper.js";
import { routeIsActive, navigateTo } from "svelte-router-spa";

const user = writable(null);
const userProfile = writable(null);

const setUser = newUser => {
  user.update(oldUser => newUser);
};

const setUserProfile = newUserProfile => {
  userProfile.update(oldUserProfile => newUserProfile);
};

const signOut = () => {
  auth.signOut();
};

const signIn = async (email, password) => {
  return new Promise(async (resolve, reject) => {
    try {
      var validationResult = validateSignInEntries(email, password);
      if (validationResult.isValid) {
        setLoader(true);
        await auth
          .signInWithEmailAndPassword(email, password)
          .then(result => { })
          .catch(error => {
            reject(error);
          });
        setLoader(false);
      } else {
        reject(validationResult);
      }
    } catch (error) {
      reject({
        message: "Something went wrong"
      });
    }
  });
};

const fetchUserProfile = async uid => {
  if (uid) {
    return await firestore
      .collection("users")
      .doc(uid)
      .get();
  }
  return null;
};

const refreshUser = async authUser => {
  if (authUser && authUser.uid) {
    var _userProfile = await fetchUserProfile(authUser.uid);
    if (_userProfile && _userProfile.data()) {
      setUserProfile({ ..._userProfile.data() });
      setUser({ ...authUser });
      if (!routeIsActive("/admin", true)) navigateTo("admin");
    }
  } else {
    setUser(null);
    setUserProfile(null);
    if (!routeIsActive("/forgot-password") && !routeIsActive("/support")) navigateTo("login");
  }
  setLoader(false);
};

export {
  user,
  userProfile,
  setUser,
  setUserProfile,
  signIn,
  signOut,
  fetchUserProfile,
  refreshUser
};
